module.exports = __webpack_public_path__ + "img/logo.6ece955a.png";